import React, { useContext, useState } from "react";
import styles from "./mains.module.scss";
import { GRID_PRODUCT_DEFAULT_ICONS } from "../../../../../helpers/constants";
import AddToCartModal from "../AddToCartModal";
import {
  findPricingViaIdHelper,
  formatCurrency,
  getSellingPriceWithoutDiscount,
} from "../../../../../helpers";
import { ToastContext } from "../../../../../hooks/context";
import { StorefrontAddIcon } from "../../../../../assets/svgIcons";

const ProductPriceRange = ({ store, variants, primaryColor }) => {
  const productVariants = variants?.map((item) => ({
    name: `${item.option} -- ${item.value}`,
    unit_price: item?.store_variant_properties[0]?.pricings?.find(
      (item) => item.pricing_type.id === 1,
    )?.unit_price,
  }));

  const { minPrice, maxPrice } = productVariants?.reduce(
    (acc, variant) => {
      if (variant.unit_price < acc.minPrice) {
        acc.minPrice = variant.unit_price;
      }
      if (variant.unit_price > acc.maxPrice) {
        acc.maxPrice = variant.unit_price;
      }
      return acc;
    },
    {
      minPrice: productVariants[0].unit_price,
      maxPrice: productVariants[0].unit_price,
    },
  );

  if (minPrice === maxPrice) {
    return (
      <p style={{ color: primaryColor }} className={styles.priceText}>
        {store?.currency_symbol}
        {minPrice?.toLocaleString()}
      </p>
    );
  }
  return (
    <p style={{ color: primaryColor }} className={styles.priceText}>
      {store?.currency_symbol}
      {minPrice?.toLocaleString()}
      {" - "}
      {store?.currency_symbol}
      {maxPrice?.toLocaleString()}
    </p>
  );
};

const MainsCard = ({ productIndex, productItem, store, menuObjectDetail }) => {
  const triggerToast = useContext(ToastContext);
  const [showAddToCartModal, setShowAddToCartModal] = useState(null);
  const productKey = productItem.is_service
    ? "store_service_properties"
    : "store_product_properties";

  const pricingDetails = findPricingViaIdHelper(
    productItem?.pricing_type?.id,
    productItem?.[productKey][0]?.pricings,
  );

  const primaryColor = menuObjectDetail?.primary_colour
    ? menuObjectDetail?.primary_colour
    : "#7647ee";

  return (
    <>
      <div
        className={styles.cardContainer}
        onClick={() => {
          if (
            menuObjectDetail &&
            menuObjectDetail.allow_payment &&
            (menuObjectDetail?.allow_in_store_checkout ||
              menuObjectDetail?.allow_delivery)
          ) {
            if (
              (productItem?.is_service
                ? productItem?.store_service_properties[0]?.stock_quantity > 0
                : productItem?.store_product_properties[0]?.stock_quantity >
                  0) ||
              productItem?.variants?.length > 0 ||
              productItem?.is_service ||
              productItem?.composite_product_type === "ON_DEMAND"
            ) {
              setShowAddToCartModal({
                ...productItem,
                store,
              });
            }
          } else {
            triggerToast(
              "Checkout is not allowed for this storefront",
              "warning",
            );
          }
        }}
      >
        <div className={styles.mainContainer}>
          {(productItem.is_service
            ? productItem?.store_service_properties[0]?.stock_quantity === 0
            : productItem?.store_product_properties[0]?.stock_quantity === 0) &&
            productItem?.composite_product_type !== "ON_DEMAND" && (
              <p className={styles.soldOut}>Sold out</p>
            )}
          <div className={styles.imageContainer}>
            <img
              src={
                productItem?.media_files.length > 0
                  ? productItem?.media_files[0].url
                  : productItem?.image_url
                    ? productItem?.image_url
                    : GRID_PRODUCT_DEFAULT_ICONS[productIndex % 5]
              }
              style={{
                objectFit:
                  productItem?.media_files.length > 0
                    ? "contain"
                    : productItem?.image_url
                      ? "contain"
                      : "cover",
              }}
              className={styles.productImg}
              alt=""
            />
            {(productItem.is_service
              ? productItem?.store_service_properties[0]?.stock_quantity === 0
              : productItem?.store_product_properties[0]?.stock_quantity ===
                0) && productItem?.composite_product_type !== "ON_DEMAND" ? (
              <></>
            ) : (
              <div className={styles.addIcon}>
                <StorefrontAddIcon color={primaryColor} />
              </div>
            )}
          </div>
          <div className={styles.descriptionContainer}>
            <div className={styles.description}>{productItem?.name}</div>

            <div className={styles.priceContainer}>
              <div className={styles.price}>
                <span className={styles.dot}></span>
                {productItem?.variants?.length > 0 ? (
                  <ProductPriceRange
                    store={store}
                    variants={productItem.variants}
                    primaryColor={primaryColor}
                  />
                ) : (
                  <p
                    style={{ color: primaryColor }}
                    className={styles.priceText}
                  >
                    {formatCurrency({
                      value: pricingDetails?.unit_price,
                      currencyCode: store?.currency_ode,
                    })}
                  </p>
                )}
              </div>

              {pricingDetails?.discount_rate ? (
                <div className={styles.offContainer}>
                  <span className={styles.offPrice}>
                    {formatCurrency({
                      value: getSellingPriceWithoutDiscount({
                        vat_percent: productItem?.vat,
                        inputed_selling_price: pricingDetails?.price,
                        discount_rate: pricingDetails?.discount_rate,
                        include_vat_in_price: productItem?.include_vat_in_price,
                      }),
                      currencyCode: store?.currency_ode,
                    })}
                  </span>
                  <span className={styles.offPerc}>
                    {pricingDetails?.discount_rate}% OFF
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {showAddToCartModal && (
        <AddToCartModal
          productIndex={productIndex}
          showAddToCartModal={showAddToCartModal}
          setShowAddToCartModal={setShowAddToCartModal}
          menuObjectDetail={menuObjectDetail}
        />
      )}
    </>
  );
};

export default MainsCard;
